.error-page {
  align-content: center;
  /*Needed for spacing against footer on mobile*/
  min-height: 40vh;
  display: flex;
  flex-direction: column;
  line-height: var(--rds-spacing--24);
  margin: var(--rds-spacing--64) auto 0 auto;
  max-width: var(--rds-readability-width);
}

.error-page-content {
  margin-left: var(--rds-spacing--16);
  margin-right: var(--rds-spacing--16);
}

.logout {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--rds-spacing--16);
  margin-top: var(--rds-spacing--32);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--rds-spacing--16);
}
